export const LANGUAGE_KEY_REG_EXP = /^[a-z0-9_]+$/;

export const REG_EXP = {
  APPLE_BUNDLE_ID: /^[a-zA-Z0-9.-]+(\.[a-zA-Z0-9.-]+)*$/,
  APPLE_TEAM_ID: /^[a-zA-Z0-9]{10}$/,
  DOOK_WEB_URL: /^https?:\/\/[a-zA-Z0-9-]+\.taker\.io$/,
  LANGUAGE_KEY_REG_EXP,
  ORGANIZATION_ID: /^[1-9][0-9]*$/,
  WEB_HOOK_URL: /^https?:\/\/.*$/,
};
